import { type ApiError } from '../../capabilities/checkout-v2/types';

export function isApiError(data: any): data is ApiError {
  return (
    data &&
    typeof data === 'object' &&
    'status' in data &&
    'detail' in data &&
    'title' in data
  );
}
